"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTypeCategoryValidationSchema = exports.useRootCauseValidationSchema = exports.useRootCauseCategoryValidationSchema = exports.useIssueValidationSchemaObject = exports.useIssueValidationSchema = exports.useIssueTypeValidationSchema = exports.useIssueTemplateValidationSchema = exports.useIssueBulkEditValidationSchema = exports.useGetSingleCustomFieldSchema = exports.useCustomFieldValidationSchema = exports.MAX_TEXT_CUSTOM_FIELD_LENGTH = exports.MAX_PARAGRAPH_CUSTOM_FIELD_LENGTH = exports.MAX_LOCATION_DETAILS_LENGTH = exports.MAX_ISSUE_TITLE_LENGTH = exports.MAX_ISSUE_DESCRIPTION_LENGTH = void 0;
var Yup = _interopRequireWildcard(require("yup"));
var _validationUtils = require("./validationUtils");
var _react = require("react");
var _hooks = require("../../state/redux/hooks");
var _issueCustomFields = require("../../state/redux/ducks/issueCustomFields");
var _sdk = require("../../../sdk");
var _issueCustomFieldMappingHooks = require("../hooks/issueCustomFieldMappingHooks");
var _useTranslations = require("../i18n/useTranslations");
var _requiredFieldsByTypeHooks = require("../hooks/requiredFieldsByTypeHooks");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MAX_ISSUE_TITLE_LENGTH = exports.MAX_ISSUE_TITLE_LENGTH = 100;
const MAX_ISSUE_DESCRIPTION_LENGTH = exports.MAX_ISSUE_DESCRIPTION_LENGTH = 1000;
const MAX_LOCATION_DETAILS_LENGTH = exports.MAX_LOCATION_DETAILS_LENGTH = 250;
const MAX_TEXT_CUSTOM_FIELD_LENGTH = exports.MAX_TEXT_CUSTOM_FIELD_LENGTH = 250;
const MAX_PARAGRAPH_CUSTOM_FIELD_LENGTH = exports.MAX_PARAGRAPH_CUSTOM_FIELD_LENGTH = 2500;

/**
 * This hook returns the custom field schema object without enforcing required fields
 */
const useGetCustomFieldSchemaObject = () => {
  const customFieldEntitiesMap = (0, _hooks.useSelector)(_issueCustomFields.getCustomFieldEntitiesMap);
  const getSingleCustomFieldSchema = useGetSingleCustomFieldSchema();
  return (0, _react.useCallback)(customFieldMappings => {
    return Object.fromEntries(customFieldMappings.map(_ref => {
      let {
        attributeDefinitionId
      } = _ref;
      const attribute = customFieldEntitiesMap[attributeDefinitionId];
      return [attributeDefinitionId, attribute && getSingleCustomFieldSchema({
        attribute
      })];
    }).filter(_ref2 => {
      let [, validation] = _ref2;
      return validation;
    }));
  }, [customFieldEntitiesMap, getSingleCustomFieldSchema]);
};

/**
 * This hook is very similar to useGetCustomFieldSchemaObject, but it enforces required fields by issue type and draft status
 */
const useGetCustomFieldSchemaObjectWithRequirednessByType = () => {
  const customFieldEntitiesMap = (0, _hooks.useSelector)(_issueCustomFields.getCustomFieldEntitiesMap);
  const getIsFieldRequiredByIssueTypeId = (0, _requiredFieldsByTypeHooks.useGetIsFieldRequiredByIssueTypeId)();
  const getSingleCustomFieldSchema = useGetSingleCustomFieldSchema();
  return (0, _react.useCallback)(_ref3 => {
    let {
      customFieldMappings,
      issueTypeId,
      status
    } = _ref3;
    return Object.fromEntries(customFieldMappings.map(_ref4 => {
      let {
        attributeDefinitionId
      } = _ref4;
      const attribute = customFieldEntitiesMap[attributeDefinitionId];
      const isRequired = status !== _sdk.IssueStatus.Draft && getIsFieldRequiredByIssueTypeId({
        issueFieldId: attribute.id,
        issueTypeId
      });
      return [attributeDefinitionId, attribute && getSingleCustomFieldSchema({
        attribute,
        isRequired
      })];
    }).filter(_ref5 => {
      let [, validation] = _ref5;
      return validation;
    }));
  }, [customFieldEntitiesMap, getSingleCustomFieldSchema, getIsFieldRequiredByIssueTypeId]);
};
const useGetSingleCustomFieldSchema = () => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const maxLengthTextValidation = (0, _validationUtils.useTextValidation)({
    maxLength: MAX_TEXT_CUSTOM_FIELD_LENGTH
  });
  const maxLengthParagraphValidation = (0, _validationUtils.useTextValidation)({
    maxLength: MAX_PARAGRAPH_CUSTOM_FIELD_LENGTH
  });
  const numericValidation = (0, _validationUtils.useNumericFieldValidation)();
  const CUSTOM_ATTRIBUTE_SCHEMA_BY_TYPE = (0, _react.useMemo)(() => ({
    [_sdk.IssueCustomAttributeType.List]: Yup.string().nullable(),
    [_sdk.IssueCustomAttributeType.Text]: maxLengthTextValidation,
    [_sdk.IssueCustomAttributeType.Paragraph]: maxLengthParagraphValidation,
    [_sdk.IssueCustomAttributeType.Numeric]: numericValidation,
    [_sdk.IssueCustomAttributeType.Date]: Yup.date(),
    [_sdk.IssueCustomAttributeType.Checkbox]: Yup.boolean()
  }), [maxLengthTextValidation, maxLengthParagraphValidation, numericValidation]);
  return _ref6 => {
    let {
      attribute,
      isRequired = false
    } = _ref6;
    let schema = CUSTOM_ATTRIBUTE_SCHEMA_BY_TYPE[attribute.dataType];
    if (isRequired) {
      schema = schema.required(T.translate("validation.required"));
    }
    return schema;
  };
};
exports.useGetSingleCustomFieldSchema = useGetSingleCustomFieldSchema;
const useIssueValidationSchema = function () {
  let requireTitleField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const issueValidationSchemaObj = useIssueValidationSchemaObject(requireTitleField);
  return Yup.object().shape(issueValidationSchemaObj);
};
exports.useIssueValidationSchema = useIssueValidationSchema;
const useIssueValidationSchemaObject = function () {
  let requireTitleField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const getIsFieldRequiredByIssueTypeId = (0, _requiredFieldsByTypeHooks.useGetIsFieldRequiredByIssueTypeId)();
  const getCustomFieldMappingsByIssueTypeId = (0, _issueCustomFieldMappingHooks.useGetCustomFieldMappingsByIssueTypeId)();
  const getCustomFieldSchemaObjectWithRequirednessByType = useGetCustomFieldSchemaObjectWithRequirednessByType();
  return {
    title: (0, _validationUtils.useTextValidation)({
      maxLength: MAX_ISSUE_TITLE_LENGTH,
      isRequired: requireTitleField
    }),
    issueTypeId: Yup.string().required(T.translate("validation.required")),
    status: Yup.string().required(T.translate("validation.required")),
    description: useIssueFieldValidationSchema({
      issueFieldId: _sdk.IssueStandardFieldIds.Description,
      maxLength: MAX_ISSUE_DESCRIPTION_LENGTH
    }),
    assignedTo: useIssueFieldValidationSchema({
      issueFieldId: _sdk.IssueStandardFieldIds.Assignee
    }),
    watchers: Yup.array().when(["issueTypeId", "status"], (issueTypeId, status) => {
      const isRequired = status !== _sdk.IssueStatus.Draft && getIsFieldRequiredByIssueTypeId({
        issueTypeId,
        issueFieldId: _sdk.IssueStandardFieldIds.Watchers
      });
      let schema = Yup.array();
      if (isRequired) {
        schema = schema.required(T.translate("validation.required")).min(1);
      }
      return schema;
    }),
    locationId: useIssueFieldValidationSchema({
      issueFieldId: _sdk.IssueStandardFieldIds.Location
    }),
    locationDetails: useIssueFieldValidationSchema({
      issueFieldId: _sdk.IssueStandardFieldIds.LocationDetails,
      maxLength: MAX_LOCATION_DETAILS_LENGTH
    }),
    gpsCoordinates: Yup.mixed().test({
      test: value => {
        if (!value) {
          return true;
        }
        const {
          latitude,
          longitude
        } = value;
        const isLatitudeValid = Yup.number().min(-90).max(90).isValidSync(latitude);
        const isLongitudeValid = Yup.number().min(-180).max(180).isValidSync(longitude);
        if (!isLatitudeValid || !isLongitudeValid) {
          throw new Yup.ValidationError(T.translate("validation.gpsCoordinates"), value, "gpsCoordinates");
        }
        return true;
      }
    }),
    dueDate: useIssueFieldValidationSchema({
      issueFieldId: _sdk.IssueStandardFieldIds.DueDate
    }),
    startDate: useIssueFieldValidationSchema({
      issueFieldId: _sdk.IssueStandardFieldIds.StartDate
    }),
    rootCauseId: useIssueFieldValidationSchema({
      issueFieldId: _sdk.IssueStandardFieldIds.RootCauseWithCategory
    }),
    // custom field validation is conditional to the current issue type.
    customAttributes: Yup.object().when(["issueTypeId", "status"], (issueTypeId, status) => {
      const customFieldMappings = getCustomFieldMappingsByIssueTypeId(issueTypeId);
      const customFieldSchemaObject = getCustomFieldSchemaObjectWithRequirednessByType({
        issueTypeId,
        status,
        customFieldMappings
      });
      return Yup.object().shape(customFieldSchemaObject);
    })
  };
};
exports.useIssueValidationSchemaObject = useIssueValidationSchemaObject;
const useIssueBulkEditValidationSchema = () => {
  const getCustomFieldMappingsByIssueTypeId = (0, _issueCustomFieldMappingHooks.useGetCustomFieldMappingsByIssueTypeId)();
  const getCustomFieldSchemaObject = useGetCustomFieldSchemaObject();
  return Yup.object().shape({
    title: (0, _validationUtils.useTextValidation)({
      maxLength: MAX_ISSUE_TITLE_LENGTH
    }),
    status: Yup.string(),
    locationDetails: (0, _validationUtils.useTextValidation)({
      maxLength: MAX_LOCATION_DETAILS_LENGTH
    }),
    description: (0, _validationUtils.useTextValidation)({
      maxLength: MAX_ISSUE_DESCRIPTION_LENGTH
    }),
    // custom field validation is conditional to the current issue type.
    customAttributes: Yup.object().when("issueTypeId", issueTypeId => {
      const customFieldMappings = getCustomFieldMappingsByIssueTypeId(issueTypeId);
      const customFieldSchemaObject = getCustomFieldSchemaObject(customFieldMappings);
      return Yup.object().shape(customFieldSchemaObject);
    })
  });
};
exports.useIssueBulkEditValidationSchema = useIssueBulkEditValidationSchema;
const useIssueTypeValidationSchema = function () {
  let {
    categoryId,
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return Yup.object().shape({
    title: (0, _validationUtils.useTypeTitleValidation)({
      categoryId,
      titlesExcludedFromValidation
    }),
    code: Yup.string().max(3, T.translate("validation.maxLength", {
      maxLength: 3
    })),
    isActive: Yup.boolean().required(T.translate("validation.required")),
    issueTypeCategoryId: Yup.string().required(T.translate("validation.required"))
  });
};

// This is a hook because it depends on a hook
exports.useIssueTypeValidationSchema = useIssueTypeValidationSchema;
const useTypeCategoryValidationSchema = function () {
  let {
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return Yup.object().shape({
    title: (0, _validationUtils.useTypeCategoryTitleValidation)({
      titlesExcludedFromValidation
    }),
    isActive: Yup.boolean().required(T.translate("validation.required")),
    issueTypeTitles: Yup.array().of((0, _validationUtils.useTypeTitleValidation)())
  });
};
exports.useTypeCategoryValidationSchema = useTypeCategoryValidationSchema;
const useRootCauseCategoryValidationSchema = function () {
  let {
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return Yup.object().shape({
    title: (0, _validationUtils.useRootCauseCategoryTitleValidation)({
      titlesExcludedFromValidation
    }),
    isActive: Yup.boolean().required(T.translate("validation.required")),
    rootCauseTitles: Yup.array().of((0, _validationUtils.useRootCauseTitleValidation)())
  });
};
exports.useRootCauseCategoryValidationSchema = useRootCauseCategoryValidationSchema;
const useRootCauseValidationSchema = function () {
  let {
    categoryId,
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return Yup.object().shape({
    title: (0, _validationUtils.useRootCauseTitleValidation)({
      categoryId,
      titlesExcludedFromValidation
    }),
    isActive: Yup.boolean().required(T.translate("validation.required")),
    rootCauseCategoryId: Yup.string().required(T.translate("validation.required"))
  });
};
exports.useRootCauseValidationSchema = useRootCauseValidationSchema;
const useCustomFieldValidationSchema = () => {
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return Yup.object({
    title: (0, _validationUtils.useTextValidation)({
      maxLength: 100,
      isRequired: true
    }),
    dataType: Yup.string().required(T.translate("validation.required")),
    description: (0, _validationUtils.useTextValidation)({
      maxLength: 500
    }),
    options: Yup.array().of((0, _validationUtils.useUnlimitedLengthTitleValidation)()).when("dataType", {
      is: _sdk.IssueCustomAttributeType.List,
      then: Yup.array().required(T.translate("validation.required")),
      otherwise: Yup.array().min(0)
    })
  });
};
exports.useCustomFieldValidationSchema = useCustomFieldValidationSchema;
const useIssueTemplateValidationSchema = function () {
  let {
    titlesExcludedFromValidation
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const numericValidation = (0, _validationUtils.useNumericFieldValidation)({
    requirePositive: true
  });
  return Yup.object().shape({
    title: (0, _validationUtils.useIssueTemplateTitleValidation)({
      titlesExcludedFromValidation
    }),
    description: (0, _validationUtils.useTextValidation)({
      maxLength: MAX_ISSUE_DESCRIPTION_LENGTH
    }),
    locationDetails: (0, _validationUtils.useTextValidation)({
      maxLength: MAX_LOCATION_DETAILS_LENGTH
    }),
    daysTilDueDate: numericValidation
  });
};
exports.useIssueTemplateValidationSchema = useIssueTemplateValidationSchema;
const useIssueFieldValidationSchema = _ref7 => {
  let {
    issueFieldId,
    maxLength
  } = _ref7;
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  const getIsFieldRequiredByIssueTypeId = (0, _requiredFieldsByTypeHooks.useGetIsFieldRequiredByIssueTypeId)();
  return Yup.string().when(["issueTypeId", "status"], (issueTypeId, status) => {
    const isRequired = status !== _sdk.IssueStatus.Draft && getIsFieldRequiredByIssueTypeId({
      issueTypeId,
      issueFieldId
    });
    let schema = Yup.string().trim().nullable(true);
    if (maxLength !== undefined) {
      schema = schema.max(maxLength, T.translate("validation.maxLength", {
        maxLength
      }));
    }
    if (isRequired) {
      schema = schema.required(T.translate("validation.required"));
    }
    return schema;
  });
};
//# sourceMappingURL=entitySchemas.js.map